import dayjs from 'dayjs';
import { MathUtil } from '@tencent/ptp-fe-common';
const { thousandsSeparated } = MathUtil;
/*
 * 格式转化
 */

// 将字符串转换成对应的类型
export const convert = (val, type) => {
  switch (type) {
    case 'int':
      return parseInt(val);
    case 'float':
      return parseFloat(val);
    case 'date':
      return new Date(Date.parse(val));
    default:
      return val.toString();
  }
};

// 小数转化为百分数，不添加%
export const percentNoAddPercent = (num, precision) => {
  typeof precision === 'undefined' && (precision = 2); // 默认保留2位

  return (Math.round(num * Math.pow(10, precision + 3)) / Math.pow(10, precision + 1));
};

// 小数转化为百分数
export const percent = (num, precision) => {
  typeof precision === 'undefined' && (precision = 2); // 默认保留2位

  return isNaN(num) ? '-' : `${(Math.round(num * Math.pow(10, precision + 3)) / Math.pow(10, precision + 1)).toFixed(precision)}%`; // 先放大比precison多1000倍（包含百分数和四舍五入的位）
};

// 添加百分号
export const percentNum = (num, precision) => {
  typeof precision === 'undefined' && (precision = 2); // 默认保留2位

  return isNaN(num) ? '-' : `${(Math.round(num * Math.pow(10, precision + 1)) / Math.pow(10, precision + 1)).toFixed(precision)}%`; // 先放大比precison多1000倍（包含百分数和四舍五入的位）
};

// 计算除法，保留小数点
export const divide = (a, b, precision) => {
  let zoom;

  if (typeof a === 'undefined' || typeof b === 'undefined') {
    return '-';
  }

  a = a.toString().replace(/,/g, '');
  b = b.toString().replace(/,/g, '');

  if (isNaN(a) || isNaN(b)) {
    return '-';
  }

  isNaN(precision) && (precision = 2);

  zoom = Math.pow(10, precision);

  // 除数不能为零
  return b != 0 ? (Math.round((a * zoom) / b) / zoom).toFixed(precision) : '-';
};

// 转换为科学计数法
export const scientific = (num, precision) => {
  const rt = [];
  let part;
  let n;
  let decimal;
  let len;

  typeof precision === 'undefined' && (precision = 2); // 默认保留2位

  if (typeof num === 'undefined' || num === null || isNaN(num)) {
    return '-';
  }

  // 小数部分直接保留
  part = ((num.toFixed && num.toFixed(precision)) || num).toString().split('.');
  n = part[0];
  decimal = part[1];
  const isNeg = Number(n) !== Math.abs(n);
  if (isNeg) {
    n = n.substring(1);
  }
  len = n.length;

  do {
    len -= 3;
    rt.push(n.substring(len < 0 ? 0 : len, len + 3));
  } while (len > 0);

  return isNaN(num) ? '-' : `${isNeg ? '-' : ''}${rt.reverse().join(',')}${decimal ? `.${decimal}` : ''}`;
};

// 转换为科学计数法
export const scientific2 = (num = 0, precision = 0) => {
  const rt = [];
  let part;
  let n;
  let decimal;
  let len;

  // 小数部分直接保留
  part = ((num.toFixed && num.toFixed(precision)) || num).toString().split('.');
  n = part[0];
  decimal = part[1];
  len = n.length;

  do {
    len -= 3;
    rt.push(n.substring(len < 0 ? 0 : len, len + 3));
  } while (len > 0);

  return isNaN(num) ? 0 : +(rt.reverse().join('') + (decimal ? `.${decimal}` : ''));
};

// 将时间点转换为时间段
export const timerange = (time) => {
  return time && time.substr(2, 1) === ':' ? `${time} - ${time.replace(':00', ':59')}` : time;
};

// 将单位分转换为元
export const cent2dollar = (num, useScientific = true) => {
  if (isNaN(num)) {
    return '-';
  }

  num = (num || 0) / 100;
  return useScientific ? scientific(num, 2) : num.toFixed(2);
};

/**
 * @description: 日期格式转换
 * @param {string} date (YYYYMMDD)
 * @return {*}
 */
export const formatDate = (date) => {
  return dayjs(date, 'YYYYMMDD').format('YYYY-MM-DD');
};

/**
 * 千分位转换为数字
 * @param {*} str 千分位格式
 * @returns 数字
 */
export const commafy2num = (str) => {
  return Number(String(str).replace(/,/gi, ''));
};

// 整数
export const renderNormalThousandsValue = (value, style = {}) => {
  const formatValue = value ? thousandsSeparated(value) : '';
  // const newValue = formatValue === '0' ? '-' : formatValue;
  return (<div style={style}>{formatValue || '-'}</div>);
};

// 环比添加样式
export const renderRatioInfo = (val) => {
  val = val || '';
  const dataInfo = { styleInfo: {}, upOrDown: '' };
  const ratioVal = percent(val);
  if (val && ![0, '0', '-'].includes(val)) {
    dataInfo.styleInfo = val.toString().includes('-') ? { color: '#67C23A' } : { color: '#ED3B3B' };
    dataInfo.upOrDown = val.toString().includes('-') ? '↓' : '↑';
  }
  return <span style={dataInfo.styleInfo}>{ratioVal}{dataInfo.upOrDown}</span>;
};

export const currencyFormat = (num = 0, precision = 2) => {
  if (num >= 100000000) {
    return `${scientific2(num / 100000000, precision)}Y`;
  }
  if (num >= 10000) {
    return `${scientific2(num / 10000, precision)}W`;
  }
  return scientific2(num, precision);
};

export default {
  convert,
  percent,
  divide,
  scientific,
  scientific2,
  timerange,
  cent2dollar,
  renderNormalThousandsValue,
  renderRatioInfo,
  percentNoAddPercent,
  currencyFormat,
};
